




























import { OrgPackageLimits } from "@/data/constants";
import { IUpmindUsageProviderData } from "@/models/providers/upmind";
import { Component, Inject, Vue } from "vue-property-decorator";

@Component({
  components: {
    "stat-view": () => import("@/components/app/global/stats/stat/statView.vue")
  }
})
export default class UpmindUsageDataGrid extends Vue {
  // Inject

  @Inject({ from: "upmindUsageProvider" })
  public $upmindUsageProvider!: () => IUpmindUsageProviderData;

  // Computed

  public get $usageData() {
    return this.$upmindUsageProvider();
  }

  public get usageData() {
    return [
      {
        label: this.$t("_.brands"),
        value: this.$usageData.brands,
        limit: this.getLimit(OrgPackageLimits.BRANDS)
      },
      {
        label: this.$t("_.payment_gateways"),
        value: this.$usageData.payment_gateways,
        limit: this.getLimit(OrgPackageLimits.PAYMENT_GATEWAYS)
      },
      {
        label: this.$t("_.provision_configs"),
        value: this.$usageData.provisioning_configurations,
        limit: this.getLimit(OrgPackageLimits.PROVISION_CONFIGURATIONS)
      },
      {
        label: this.$t("_.users"),
        value: this.$usageData.users,
        limit: this.getLimit(OrgPackageLimits.USERS)
      },
      {
        label: this.$t("_.clients"),
        value: this.$usageData.clients,
        limit: this.getLimit(OrgPackageLimits.CLIENTS)
      }
    ];
  }

  // Methods

  public getLimit(field: OrgPackageLimits) {
    return this.$usageData.packageLimits?.[field];
  }
}
